<template>
  <path d="M12 16L6 10H18L12 16Z" fill="#211A4D"/>
</template>